module.exports = __webpack_public_path__ + "static/media/pokerlistings.da7c40db.svg";